import { useEffect, useState } from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import React from "react";
import { useHistory, useParams } from "react-router";
import { Container, Typography, Grid, TextField, Button, Box } from "@mui/material";
import { useBusinessContext } from "../../context/business-context";

const GeneralSettings = () => {
  const { selectedBusiness, selectedBusinessId, selectedBusinessName, setSelectedBusinessName } =
    useBusinessContext();
  const history = useHistory();

  const { name } = useParams<{ name: string }>();
  const [status, setStatus] = useState({ loading: false, error: false });
  const [settings, setSettings] = useState<any>({});
  const getSettings = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      //formData.append("business_id", selectedBusinessId);
      formData.append("business_id",selectedBusiness.business_id );
      formData.append("branch_id",selectedBusiness.branch_id );

      const response = await axios.post(
        `${baseUrl()}settings/loadsettingsByBranchID`,
        formData,
        config
      );
      console.log(response);
      const { data } = response.data;
      // console.log(data);
      setSelectedBusinessName(data.siteName);
      const fetchedResults = data;
      setSettings(fetchedResults);

    } catch (error) {
      console.error(error);
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id",selectedBusiness.business_id );      formData.append("branch_id",selectedBusiness.branch_id );
      Object.keys(settings).forEach((key) => {
        formData.append(key, settings[key]);
      });

      const response = await axios.post(
        `${baseUrl()}settings/edit_branch`,
        formData,
        config
      );
      console.log(response);
      getSettings();
    } catch (error) {
      console.error("Error updating settings:", error);
      setStatus({ loading: false, error: true });
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  useEffect(() => {
    getSettings();
    return () => {};
  }, []);
  return (
    <IonPage>
      <IonHeader>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
            {/* <Business className={styles.titleIcon} /> */}
           {selectedBusinessName} - Settings
          </Typography>

          <Button
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
            style={{ marginLeft: 10 }}
          >
            Go Back
          </Button>
        </Box>
      </IonHeader>

      
      <IonContent fullscreen>
        <Container sx={{ m: 3 }}>
          {/* <Typography variant="h4" gutterBottom>
            Settings
          </Typography> */}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {Object.keys(settings)
                .filter(
                  (key) =>
                    key !== "id" && key !== "business_id" && key !== "branch_id"
                )
                .map((key, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <TextField
                      fullWidth
                      label={key}
                      name={key}
                      value={(settings as any)[key]}
                      onChange={handleChange}
                      variant="outlined"
                    />
                  </Grid>
                ))}
            </Grid>
            <Button
              sx={{ mt: 3 }}
              type="submit"
              variant="contained"
              color="primary"
            >
              Save Settings
            </Button>
          </form>
        </Container>

        <IonLoading
          message="Please Wait..."
          spinner="circles"
          isOpen={status.loading}
        />
      </IonContent>
    </IonPage>
  );
};

export default GeneralSettings;
